import { Tabs } from "antd";
import React from "react";
import CropTab from "./CropTab";
import CollapsibleCardHeader from "../../../../../components/atoms/cardHeader/collapsibleCardHeader";

const TargetCropsDetail = ({ productbase, detail, productId }) => {
  const tabNames = [
    { key: "1", name: "Annual" },
    { key: "2", name: "Perennial" },
  ];
  const items = tabNames?.map(({ key, name }) => {

    return {
      key,
      label: `${name} Crops`,
      children: (
        <CropTab
          name={name.toLowerCase()}
          productbase={productbase}
          detail={detail}
          productId={productId}
        />
      ),
    };
  });

  return (
    <div className="card">
      <CollapsibleCardHeader
        name="Target Crops"
        target="collapseFour"
        id="headingFour"
      />
      <div
        id="collapseFour"
        className="collapse"
        data-parent="#vender_product_preview"
      >
        <div className="card-body">
          <div id="target_crops">
            <label className="font-weight-bolder font-size-lg mb-3 d-block h5">
              Selected Target Crops
            </label>
          </div>

          <div className="separator separator-solid my-5"></div>

          <Tabs defaultActiveKey="1" items={items} />
        </div>
      </div>
    </div>
  );
};

export default TargetCropsDetail;
